import { endOfObjectLiteral } from "./end-of-object-literal";
import { hasSpreadInCode } from "./has-spread-in-code";
import { metaDeclarationOpen } from "./meta-declaration-open";
import { topLevelStringField } from "./top-level-string-field";

/**
 * `meta.name` off a workflow script, or undefined when the parser would refuse
 * it: a row naming a run that does not exist is worse than an unnamed one.
 */
export function metaNameInScript(script: string): string | undefined {
  const open = metaDeclarationOpen(script);
  if (open === -1) return undefined;
  const end = endOfObjectLiteral(script, open);
  if (end === -1) return undefined;
  const literal = script.slice(open, end);
  if (hasSpreadInCode(literal)) return undefined;
  const name = topLevelStringField(literal, "name");
  // trim() is the parser's EMPTINESS test; the value it stores is untrimmed.
  return name?.trim() && topLevelStringField(literal, "description")?.trim()
    ? name.slice(0, 80)
    : undefined;
}
